import { KEYS, repository } from '@repositories/Repository';
import type { TenantRequestCreateDTO } from '@repositories/tenantRequestRepository/tenantRequest.types';
import type { TenantRequestRepository } from '@repositories/tenantRequestRepository/impl/TenantRequestRepository';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const tenantRequestRepo = repository.get<TenantRequestRepository>(KEYS.TENANT_REQUEST_REPOSITORY);
const tenantRequestQueryKey = {
  all: ['tenantRequest'] as const,
  lists: () => [...tenantRequestQueryKey.all, 'list'] as const,
};

export const useAddTenantRequest = () => {
  const queryClient = useQueryClient();

  const result = useMutation({
    mutationFn: async (data: TenantRequestCreateDTO) => {
      await tenantRequestRepo.create(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantRequestQueryKey.lists() });
    },
  });

  return { ...result };
};
